export default __webpack_public_path__ + "static/media/woman_cell_phone_blue.a326139b.svg";